import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. The component lives in `index.lazy.tsx` so the
// wizard bundle (forms, adapter spec catalog, test-event card) loads on
// demand for first-run users and stays out of the dashboard bundle for
// everyone else.
export const Route = createFileRoute("/app/setup/")({});
